module.exports = __webpack_public_path__ + "img/marcogrimalt.f5c3cd99.jpg";